{
  "0_ALREADY_EXISTS": "\"{0}\" již existuje.",
  "0_OF_1": "{0} z {1}",
  "ACCOUNT_ID": "ID účtu",
  "ADD": "Přidat",
  "ADD_REMOVE_FIELDS": "Přidat/odebrat pole",
  "AN_ERROR_OCCURED": "Došlo k chybě",
  "APPLY": "Použít",
  "APPLY_CHANGES": "Použít změny",
  "ATTACH": "Připojit",
  "ATTACH_AS_LINK": "Připojit jako odkaz",
  "ATTACHING": "Připojování...",
  "AUTOMATICALLY_RENAME": "Automaticky přejmenovat",
  "BACK": "Zpět",
  "BROWSE": "Procházet",
  "CANCEL": "Zrušit",
  "CHARACTER_COUNT": "Počet znaků:",
  "CLOSE": "Zavřít",
  "CLOUD": "Cloud",
  "COMMENT": "Komentář",
  "CONFIGURE_REPOSITORY_SETTINGS": "Konfigurovat nastavení úložiště",
  "COULD_NOT_SAVE_0": "Nelze uložit \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Nelze uložit \"{0}\". Typ souboru není podporován.",
  "DATA": "Data",
  "DATE": "Datum",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Pole data musí být ve formátu {0}.",
  "DATE_PROVIDED_IS_INVALID": "Zadané datum je neplatné.",
  "DATE_TIME": "Datum/Čas",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Pole data/času musí být ve formátu {0}.",
  "DEFAULT_FOLDER": "<Výchozí složka>",
  "DETAILS": "Detaily",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Chcete použít změny polí?",
  "DOCUMENT_NAME_IS_EMPTY": "Název dokumentu je prázdný",
  "DRAG_DROP_FILE": "Přetáhněte soubor",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "V této složce již existuje položka s názvem '{0}'. Vyberte prosím jiný název.",
  "ENTRY_ID": "ID položky",
  "ENTRY_NAME": "Název položky",
  "ENTRY_NOT_FOUND": "Položka nebyla nalezena.",
  "ERROR_DOWNLOADING_DOCUMENT": "Chyba při stahování dokumentu.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Při připojování k serveru došlo k chybě.",
  "ERROR_SAVING": "Chyba při ukládání:",
  "FAILED_TO_OPEN_FOLDER": "Nepodařilo se otevřít složku",
  "FAILED_TO_SAVE_COLON": "Uložení selhalo:",
  "FAILED_TO_SAVE_PERIOD": "Uložení selhalo.",
  "FEEDBACK": "Zpětná vazba",
  "FIELDS": "Pole",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Tento soubor překračuje maximální velikost 25 MB.",
  "FILE_EXTENSION": "Přípona souboru",
  "FILE_LOCKED": "Soubor je zamčen.",
  "FILE_MODIFIED": "Soubor upraven",
  "FILE_NAME": "Název souboru",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Názvy souborů nesmí obsahovat zpětné lomítko",
  "FOLDER": "Složka",
  "INTEGER": "Celé číslo",
  "LIST": "Seznam",
  "LOADING": "Načítání...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Dlouhá pole musí být celá čísla mezi 0 a 3 999 999 999",
  "LONG_INTEGER": "Dlouhé celé číslo",
  "NAME": "Název",
  "NAME_CONFLICT": "Konflikt názvů",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Potřebujete pomoc s přihlášením? Kontaktujte svého správce Laserfiche pro pomoc.",
  "NEW_FOLDER": "Nová složka",
  "NO": "Ne",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Nebyly přiřazeny žádné další pole",
  "NO_FOLDER_SELECTED": "Není vybrána žádná složka.",
  "NO_MATCHING_ENTRIES_FOUND": "Nebyly nalezeny žádné odpovídající položky",
  "NO_MATCHING_FIELDS_FOUND": "Nebyly nalezeny žádné odpovídající pole.",
  "NO_TEMPLATE_ASSIGNED": "Není přiřazena žádná šablona",
  "NOT_AVAILABLE_WITH_TOKENS": "Není dostupné s tokeny",
  "NUMBER": "Číslo",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Číselné pole musí obsahovat platné číslo",
  "OK": "OK",
  "ONE_OR_MORE_FIELDS_INVALID": "Jedno nebo více polí je neplatných.",
  "OPEN": "Otevřít",
  "OPEN_IN_LASERFICHE": "Otevřít v Laserfiche",
  "OPTIONAL": "Volitelné",
  "OR": "nebo",
  "PARENT_FIELD": "Nadřazené pole",
  "PARENT_ID": "ID nadřazeného",
  "PARENT_NAME": "Název nadřazeného",
  "PLEASE_SELECT_A_FOLDER": "Vyberte prosím složku",
  "REASON_FOR_DOWNLOADING": "Důvod stahování",
  "REFRESH": "Obnovit",
  "REMOVE": "Odstranit",
  "REMOVE_REPOSITORY": "Odstranit úložiště?",
  "REPOSITORY": "Úložiště",
  "REPOSITORY_COUNT": "Počet repozitářů",
  "REPOSITORY_ID": "ID úložiště",
  "REPOSITORY_NAME": "Název úložiště",
  "REQUIRED": "Povinné",
  "REQUIRED_FIELD_IS_EMPTY": "Povinné pole je prázdné",
  "SAVE_CHANGES": "Uložit změny",
  "SAVE_TO_LASERFICHE": "Uložit do Laserfiche",
  "SAVED_TO_LASERFICHE": "Uloženo do Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Uloženo do Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "Uloženo s chybějícími metadaty:",
  "SAVING": "Ukládání...",
  "SEARCH_FIELDS": "Vyhledávací pole",
  "SELECT": "Vybrat",
  "SELECT_REASON": "Vyberte důvod",
  "SELF_HOSTED": "Vlastní hosting",
  "SESSION_COUNT": "Počet relací",
  "SETTINGS": "Nastavení",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Krátká pole musí být celá čísla mezi 0 a 64999",
  "SIGN_IN": "Přihlásit se",
  "SIGN_IN_TO_LASERFICHE": "Přihlásit se do Laserfiche",
  "SIGN_OUT": "Odhlásit se",
  "SIGNING_IN": "Přihlašování...",
  "SIGNING_OUT": "Odhlašování...",
  "SKIP_THIS_FILE": "Přeskočit tento soubor",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Něco se pokazilo. Zkuste to prosím později.",
  "SUBMIT": "Odeslat",
  "SUGGESTION": "Návrh",
  "TEMPLATE": "Šablona",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Šablona se nepodařilo načíst.",
  "TEXT": "Text",
  "THANK_YOU_FOR_SUBMISSION": "Děkujeme za váš příspěvek!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Toto pole má maximální povolenou délku {0} znaků.",
  "THIS_FOLDER_IS_EMPTY": "Tato složka je prázdná.",
  "TIME": "Čas",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Časová pole musí být ve formátu {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Nelze načíst všechna pole:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Nelze získat informace o úložišti:",
  "UNKNOWN_ERROR": "Neznámá chyba.",
  "USER_NAME": "Uživatelské jméno",
  "YES": "Ano"
}
